<template>
  <div class="p-4">
    <l-l-selection @click="onSelectionClick" :timeseries="timeseries" />
    <l-l-chart ref="chart" v-show="showChart" />
  </div>
</template>

<script>
import LLSelection from "./LLSelection";
import LLChart from "./LLChart";
import HistoricalService from "@/helpers/services/viewer/historical.service";
import * as moment from "moment";
import Notify from "@/helpers/notify";

export default {
  name: "Historical",
  components: {
    LLSelection,
    LLChart
  },
  data() {
    return {
      timeseries: [],
      showChart:false      
    };
  },
  mounted() {
    Notify.loadData(null, this.loadInitialData);
  },
  methods: {
    async loadInitialData() {
      this.timeseries = await HistoricalService.timeseries();
    },
    async loadData (timeseries, from, to, onlyValidValues, viewAsBar) {
      this.showChart = true;
      this.$refs.chart.removeSeries();
      //const t = timeseries.map(function(item) { return "'" + item.value; }).join("',") + "'";
      
      console.log(timeseries);
      // debugger
      const series = await HistoricalService.observations(timeseries, from, to, onlyValidValues, viewAsBar);
      this.$refs.chart.addSeries(series);
    },
    async onSelectionClick(selections) {            
      Notify.loadData(null, await this.loadData, selections.timeseries, selections.from, selections.to, selections.onlyValidValues, selections.viewAsBar);
    }
  }
};
</script>
